import React from 'react';
import {toJS} from 'mobx';
import {observer} from 'mobx-react';

import {DatePicker, Row, Col, Input, Select} from 'antd';
import {exportFile} from '@src/Utils';
import user_store, {pagination_store, filter_store} from '@store/User/UserList/UserStore';
import {Button} from 'antd/lib/radio';
import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";
import moment from "moment";
import MySearchComponent from '@ViewsDashboard/Common/MySearchComponent';

const Search = Input.Search;
const Option = Select.Option;

@observer
class UserFilterForm extends React.Component {
  render() {

    let numberStyle = {
      fontSize: '22px',
      fontWeight: '700',
      marginLeft: '30px'
    };
    let tipStyle = {
      marginLeft: '10px'
    };

    return (
      <Row type="flex"
           style={{
             flex: '1'
           }}
      >
        {<Col style={{
          lineHeight: '35px'
        }}>
          <MySearchComponent
            defaultValue={{
              typeMode: CustomerTypeSelect.TYPE_MODE_USER,
              type: CustomerTypeSelect.getTypeName(CustomerTypeSelect.TYPE_MODE_USER, filter_store.type),
              search: filter_store.search ? filter_store.search : '',
            }}
            hideAutoComplete
            hideDatePicker
            onClick={(values) => {

              filter_store.setAttr({
                search: values.search,
                type: 1
              });
              user_store.reloadDatas();

            }}
          />
        </Col>
        }
        <Col
          style={{
            lineHeight: '35px',
            marginLeft: '15px',
            flex: 1,
            textAlign: 'right',
          }}>
          <span style={numberStyle}>{user_store.total}</span>
          <span style={tipStyle}>会员总数</span>

          <span style={numberStyle}>{user_store.new_num}</span>
          <span style={tipStyle}>今日新增</span>

        </Col>
      </Row>
    )
  }
}


export default UserFilterForm;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/UserFilterForm.jsx